module.exports = __webpack_public_path__ + "img/youtube.0038846.png";